import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import cs from "./locales/cs/translation.json";
import en from "./locales/en/translation.json";
import de from "./locales/de/translation.json";
import pl from "./locales/pl/translation.json";
import sk from "./locales/sk/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      sk: { translation: sk },
    },
    fallbackLng: {
      default: ["en", "cs"],
    },
    supportedLngs: ["cs", "en", "de", "pl", "sk"],
    load: "languageOnly",
    debug: false,
    returnEmptyString: false,
    returnNull: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
